var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10V13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14V13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10V18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10V23Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H20V8H12V4ZM7 28V7H10V10H22V7H25V15H27V7C27 5.896 26.104 5 25 5H22V4C22 2.896 21.104 2 20 2H12C10.895 2 10 2.896 10 4V5H7C5.895 5 5 5.896 5 7V28C5 29.105 5.895 30 7 30H16V28H7Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19V21.413C19.225 19.373 21.452 18 24 18C27.86 18 31 21.14 31 25C31 28.86 27.86 32 24 32V30C26.757 30 29 27.757 29 25C29 22.243 26.757 20 24 20C21.955 20 20.198 21.237 19.424 23H22V25H16V19H18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadList);
export default __webpack_public_path__ + "static/media/upload-list.e6c8c9654edf7e4d0a4fc422b53b6870.svg";
export { ForwardRef as ReactComponent };